import { render, staticRenderFns } from "./SelectPositionsForAutoThresholdModal.vue?vue&type=template&id=4eb70490&scoped=true&"
import script from "./SelectPositionsForAutoThresholdModal.vue?vue&type=script&lang=js&"
export * from "./SelectPositionsForAutoThresholdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb70490",
  null
  
)

export default component.exports